import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'
import { registerLicense } from '@syncfusion/ej2-base'
import { oneTimeCacheBust } from './oneTimeCacheBust'
import * as Sentry from '@sentry/angular'
import HyperDX from '@hyperdx/browser'

registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxiXX5fc3NXTmdbVUw=')

if (environment.HYPERDX_ENABLED) {
  HyperDX.init({
    apiKey: environment.HYPERDX_API_KEY,
    service: 'aspik-frontend',
    tracePropagationTargets: [/oa-backend\.aspik\.is/, /oa-staging-backend\.aspik\.is/, /ukaz-backend\.aspik\.is/],
    consoleCapture: false,
    advancedNetworkCapture: false,
    url: environment.HYPERDX_INGEST_URL,
  })
}

if (environment.production) {
  oneTimeCacheBust() // TODO: ASPIK-689 remove after 09/2025

  enableProdMode()

  // Initialize Sentry if enabled
  if (environment.SENTRY_ENABLED) {
    Sentry.init({
      dsn: environment.SENTRY_DSN,
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
    })
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err))
} else {
  // Initialize Sentry if enabled
  if (environment.SENTRY_ENABLED) {
    Sentry.init({
      dsn: environment.SENTRY_DSN,
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
    })
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err))
}
